import { limparTexto } from "../utils/text";


export default {
  bind(el) {
    el.addEventListener('input', (e) => {
      const valorLimpo = limparTexto(e.target.value);

      if (e.target.value !== valorLimpo) {
        e.target.value = valorLimpo;

        // força atualização do v-model
        el.dispatchEvent(new Event('input'));
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/directives/semAcentos.js